<div class="header-container">
  <app-detail-header-template>
    <div class="header-section" top-left>
      <div class="header-section__title">UPLOAD PROJECT SHEET</div>
      <div class="header-section__description">
        The Project Upload page lets you upload and create new projects in bulk.
      </div>
    </div>
  </app-detail-header-template>
</div>


<div class="bulk-project">

  <div class="list-container">

    <div class="bulk-project__upload">
      <div class="upload__section upload__section--top">
        <span class="upload__instruction--header bold">Project Upload Instructions</span>
        <b class="upload__instruction--text-header">File Requirements</b>
        <ul class="upload__instruction--text">
          <li>Must be <u>.xlsx</u> format.</li>
          <li>Maximum number of projects in the sheet can be added: 100</li>
          <li>First row of the exported sheet is not editable and <b>SourceProjectName</b> is the name of the exported project details from the platform.</li>
        </ul>

        <b class="upload__instruction--text-header">For Risk project types:</b>
        <span class="upload__instruction--text">Provide the following information on the upload file:</span>
        <ul class="upload__instruction--text">
          <li>Project Name &ndash; Name of the project</li>
          <li>Project Owner &ndash; Name of the project Owner</li>
          <li>Review Period Start Date</li>
          <li>Review Period End Date</li>
          <li>Project Start Date</li>
          <li>Project End Date</li>
          <li>Coding Review Mode &ndash; Specify the version of coding review</li>
          <li>Coding Model &ndash; Specify the verify of coding model</li>
          <li>Line of Business &ndash; Mention the LOB</li>
          <li>Group</li>
          <li>Copy of Provider packet &ndash; Yes or No? Indicate whether the provider packet contents should be copied from the source project. Selecting Yes will replicate the packet details into the new project.</li>
          <li>Source Project Name &ndash; The name of the project exported from the platform</li>
        </ul>

        <b class="upload__instruction--text-header">For IVA project type:</b>
        <span class="upload__instruction--text">Provide the following information on the upload file:</span>
        <ul class="upload__instruction--text">
          <li>Project Name &ndash; Name of the project</li>
          <li>Project Owner &ndash; Name of the project Owner</li>
          <li>Review Period Start Date</li>
          <li>Review Period End Date</li>
          <li>Project Start Date</li>
          <li>Project End Date</li>
          <li>Coding Model &ndash; Specify the verify of coding model</li>
          <li>Line of Business &ndash; Mention the LOB</li>
          <li>Group</li>
          <li>Copy of Provider packet &ndash; Yes or No? Indicate whether the provider packet contents should be copied from the source project. Selecting Yes will replicate the packet details into the new project.</li>
          <li>Source Project Name &ndash; The name of the project exported from the platform</li>
        </ul>

        <b class="upload__instruction--text-header">For HEDIS project type:</b>
        <span class="upload__instruction--text">Provide the following information on the upload file:</span>
        <ul class="upload__instruction--text">
          <li>Project Name &ndash; Name of the project</li>
          <li>Project Owner &ndash; Name of the project Owner</li>
          <li>Project Start Date</li>
          <li>Project End Date</li>
          <li>Measurement Year</li>
          <li>Reporting Year</li>
          <li>Group</li>
          <li>Copy of Provider packet &ndash; Yes or No? Indicate whether the provider packet contents should be copied from the source project. Selecting Yes will replicate the packet details into the new project.</li>
          <li>Source Project Name &ndash; The name of the project exported from the platform</li>
        </ul>
      </div>
      <div class="upload__documentUpload upload__section upload__section--bottom">

        <label class="label">Upload File</label>
        <div class="required-files upload__spacing">
          <div class="required-files__file">
            <div class="required-files__name"></div>

            <app-file-upload-new class="required-files__upload" #appFileUpload name="dataload[]" chooseLabel="BROWSE"
              accept=".xlsx" [multiple]="false" [showUploadButton]="true" [showCancelButton]="true"
              (onUpload)="uploadDocument($event)">
            </app-file-upload-new>
          </div>
        </div>

        <div class="upload__selected-file" *ngIf="isFileUploaded">
          <span class="upload__selected-file--label bold">Selected file:</span>
          <span class="upload__selected-file--name">{{fileName}}</span>
        </div>

        <div class="text-right" *ngIf="isFileUploaded">
          <app-button classes="secondary" class="upload__documentUpload--button" text="RESET" (onClick)="reset()"></app-button>
          <app-button classes="primary--button" text="VALIDATE" (onClick)="validate()"></app-button>
        </div>
      </div>
    </div>

    <div class="bulk-project__summary validationSummary" *ngIf="isValidated">
      <h4 class="header">{{summaryHeader}}</h4>
      <div class="summary-section">
        <div class="summary-body">
          <div class="summary-body__header">
            <div class="summary-body__type bold">TYPE</div>
            <div class="summary-body__details bold">DETAILS</div>
          </div>
          <div class="summary-body__content" [class.odd]="odd"
            *ngFor="let item of summaryReport; let odd = odd, let last = last, trackBy: trackByIndex">
            <div class="summary-body__type">{{item.key}}</div>
            <div [ngClass]="getValidationMessageClass(item.value)" class="summary-body__details">{{item.value}}</div>
          </div>
        </div>
        <div class="summary-footer">
          <div *ngIf="!hasPassed" class="text-center">
            <app-button classes="secondary" class="summary-footer__button" text="DOWNLOAD VALIDATION ISSUES" (onClick)="downloadValidationIssues()">
            </app-button>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<app-result-modal
  class="processing-modal"
  [(visible)]="isProcessingVisible"
  [header]="processingHeaderText"
  [allowClose]="false">
  <div class="processing-modal__icon-spinner">
    <app-icon iconName="spinner" spin=true></app-icon>
  </div>
  <br>
  <p class="text-center">This might take few minutes</p>
</app-result-modal>
